<template>
  <div class="product_list">
    <ul>
      <template v-for="(product, index) in productArr" class="product_detail">
        <li class="one_product" :key="index">
          <div class="photo">
            <img :src="require('@/assets/' + product.imgUrl)" alt="" />
          </div>
          <div class="info">
            <p class="tit">{{ product.name }}</p>
            <p class="introduce">{{ product.explain }}</p>
            <ul>
              <li class="range">
                <div class="key">
                  {{ product.rateRangeLeft }}<b class="symbol">%～</b
                  >{{ product.rateRangeRight }}<b class="symbol">%</b>
                </div>
                <div class="value">参考利率范围</div>
              </li>
              <li class="comm">
                <div class="key">{{ product.monthRange }}</div>
                <div class="value">融资期限</div>
              </li>
              <li class="comm">
                <div class="key">{{ product.moneyRange }}</div>
                <div class="value">融资额度</div>
              </li>
            </ul>
          </div>
          <div class="btn" @click="gotoLocation(product, index)">
            查看详情
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["logInfo"],
  data() {
    return {
      productArr: this.logInfo
    };
  },
  created() {
    if (this.$route.query.accessToken) {
      sessionStorage.setItem("accessToken", this.$route.quer.accessToken);
    }
  },
  methods: {
    gotoLocation(prod, index) {
      // this.$router.push({
      //   path: "/productdetail",
      //   query: {
      //     index: index
      //   }
      // });
      window.parent.frames.location.href =
        "https://www.zgcqianfan.com/finance/detail.jsp?index=" + Number(index);
    }
  }
};
</script>
<style lang="scss" scoped>
ul,
ol {
  list-style: none;
}
/* 产品列表 */
.product_list {
  height: auto;
  margin: -110px 0 0 10%;
  width: 80%;
  padding-bottom: 29px;
  .one_product {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 40px;
    margin-bottom: 19px;
    .btn {
      cursor: pointer;
      font-family: SourceHanSansCN-Medium;
      width: 106px;
      height: 40px;
      background-color: #3da0fd;
      font-size: 14px;
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      color: #ffffff;
    }
    .photo {
      width: 88px;
      height: 88px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      flex: 1;
      padding: 0 10% 0 4%;
      .tit {
        font-family: SourceHanSansCN-Medium;
        font-size: 20px;
        margin-bottom: 15px;
        font-weight: bold;
        font-stretch: normal;
        color: #333333;
      }
      .introduce {
        font-family: SourceHanSansCN-Medium;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #666666;
      }
      ul {
        margin-top: 46px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .range {
          width: 170px;
          .key {
            font-family: ArialMT;
            font-size: 30px;
            font-weight: bold;
            font-stretch: normal;
            color: #3da0fd;
          }
          .symbol {
            font-size: 14px;
            color: #3da0fd;
          }
          .value {
            font-size: 14px;
            color: #666666;
            margin-top: 25px;
            font-family: SourceHanSansCN-Medium;
          }
        }
        .comm {
          .key {
            font-family: SourceHanSansCN-Medium;
            color: #666;
            font-size: 20px;
            line-height: 40px;
          }
          .value {
            font-size: 14px;
            color: #666666;
            margin-top: 25px;
            font-family: SourceHanSansCN-Medium;
          }
        }
      }
    }
    .tishiDIv {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .mes {
        font-size: 16px;
        line-height: 32px;
        p {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          b {
            width: 20px;
            height: 20px;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/qianfan/component/orderlist.vue